<template>
<div class="main">
  <FormHero v-if="this.agents != undefined" :formtype="'appraisal'" :stage="'first'" :agentdata="this.agents"></FormHero>

  <div class="container ut-px-4">

    <vue-form :state="formstate">

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.name)">

        <input type="text" v-gaEvent="{ category: gacategory, action: 'Click Name Field', label: ''}" placeholder="Full name *" name="name" class="form-control" required v-model.lazy="model.name">

        <field-messages name="name" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Name is a required field</div>
        </field-messages>

      </validate>

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.email)">

        <input type="email" v-gaEvent="{ category: gacategory, action: 'Click Email Field', label: ''}" placeholder="Email *" name="email" class="form-control" required v-model.lazy="model.email">

        <field-messages auto-label name="email" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Email is a required field</div>
          <div slot="email">Email is invalid</div>
        </field-messages>

      </validate>

      <validate auto-label class="form-group required-field ut-mb-2" :class="fieldClassName(formstate.phone)">

        <input type="tel" v-gaEvent="{ category: gacategory, action: 'Click Phone Field', label: ''}" placeholder="Phone number *" name="phone" class="form-control" required pattern="^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$" v-model.lazy="model.phone">

        <field-messages name="phone" show="$touched || $submitted" class="form-control-feedback">
          <div slot="required">Phone number is a required field</div>
          <div slot="pattern">Phone number is invalid</div>
        </field-messages>

      </validate>
    </vue-form>

    <button class="ut-oa-btn ut-mt-12 ut-block ut-mb-8" :to="{name: 'RequestAppraisalStep2'}" v-gaEvent="{ category: gacategory, action: 'Click Next Step', label: `${this.multiform} Contact`}" @click="validate()">Next step</button>

  </div>
</div>
</template>

<script>
import axios from 'axios';
import FormHero from '@/components/FormHero.vue';
import Vue from 'vue';
import VueForm from 'vue-form';

Vue.use(VueForm, {
  inputClasses: {
    valid: 'form-control-success',
    invalid: 'form-control-danger',
  },
});

export default {
  name: 'RequestAppraisalStep1',
  props: {
    userId: null,
  },
  components: {
    FormHero,
  },
  data() {
    return {
      multiform: "Single",
      agents: [],
      gacategory: 'Contact Agent Form',
      formstate: {},
      model: {
        name: '',
        email: '',
        phone: '',
        department: null,
        comments: '',
        notValidated: '',
        agree: false,
      },
      name: null,
      email: null,
      phone: null,
      errors: [],
    };
  },
  methods: {
    fieldClassName(field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'hasSuccess';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'hasDanger';
      }
    },
    validate() {
      this.formstate.$submitted = true;

      if (this.formstate.$valid) {
        this.reqestappraisaldata = {
          address: null,
          lowpricerange: null,
          highpricerange: null,
          sellingwhat: null,
          sellingtime: null,
          name: this.model.name,
          email: this.model.email,
          phone: this.model.phone,
        };

        this.$store.state.reqestappraisaldata = this.reqestappraisaldata;
        this.$router.push({
          name: 'RequestAppraisalStep2',
          query: {
            ak: this.$route.query.ak,
          },
          params: {
            agent: this.agents,
            multiform: this.multiform,
          },
        });
      }
    },
  },
  created() {
    if (this.$store.state.agentdata == undefined) {
      this.$router.push({
        name: 'Home',
        query: this.$store.state.query,
      });
    } else {

    if (this.$route.params.agents != undefined) {
      this.agents = this.$route.params.agents;
      this.$store.state.selectedagents = this.agents;
      this.multiform = 'Multi Agent';
    } else {
      this.multiform = 'Single';
      for (let i = 0; i < this.$store.state.agentdata.length; i++) {
        if (this.$store.state.agentdata[i].AgentKey == this.$route.query.ak) {
          this.agents.push(this.$store.state.agentdata[i]);
        }
      }
      this.$store.state.selectedagents = this.agents;
    }
  }
  },
};
</script>

<style scoped lang="scss">
.main {
    max-width: 600px;
    margin: 0 auto;

    .title {
        text-align: center;
    }
}
</style>
